import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

export class Daffney extends Lit3formBlock {
  static get characterName() {
    return 'daffney';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid daffney-layout">
          <div class="images">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    return !!image.url
      ? html`
          <a
            class="${classMap(this.imageWrapperClass(image))}"
            href=${this.imageHref(image)}
          >
            ${this.imageInternalHtml(image)}
          </a>
        `
      : html`
          <a
            class="${classMap(this.imageWrapperClass(image))}"
            href=${this.imageHref(image)}
            target="_blank"
            rel="noopener"
          >
            ${this.imageInternalHtml(image)}
          </a>
        `;
  }

  imageInternalHtml(image) {
    return !!image.text
      ? html`
          <div class="image">
            <img src=${this.imageUrl(image)} />
            <div class="image-driver">
              ${unsafeHTML(this.withLineBreaks(image.text))}
              <img
                class="right-arrow"
                src="/static/icons/SVG/arrow-black-5x10.svg"
              />
            </div>
          </div>
        `
      : html`
          <div class="image">
            <img src=${this.imageUrl(image)} />
          </div>
        `;
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    return image.full_width
      ? this.imagebossUrl(image.src, null, 500)
      : this.imagebossUrl(image.src, 580, 500);
  }

  imageWrapperClass(image) {
    return {
      'image-wrapper': true,
      'image-wrapper-full': image.full_width,
    };
  }

  get ctaData() {
    return JSON.stringify(this.content.cta);
  }

  get imagesArr() {
    if (!this.content.images || this.content.images.length === 0) {
      return [];
    }
    return this.content.images;
  }
}
Daffney.defineElement();
